
import { customEvent } from "./customEvent";

export const updateCart = async (response, disableSuccess) => {
  if (response) {
    if(response.description) {
      if(response.status !== 200) {
        window.toast.error({
          message: response.description,
          icon: false
        })
      }
      else {
        if(!disableSuccess) {
          window.dispatchEvent(new Event('dynamic-cart-open'));
        }
      }
    }
    else {
      if(!disableSuccess) {
        window.dispatchEvent(new Event('dynamic-cart-open'));
      }
    }
  }

  customEvent(window, 'ajax-cart', {
    cartSections: response.sections,
    items: response.items
  });
}

/**
 * Adds an item to cart and updates the cart count
 *
 * @param {String} variantId - variant to add
 * @param {Int} quantity - quantity to add
 * @param {String} sellingPlan - id of selling plan if applicable
 */
export const addToCart = async (variantId, quantity, sellingPlan = null) => {
  window.dispatchEvent(new Event('dynamic-cart-loading'));

  let item = {
    id: variantId,
    quantity: quantity
  };

  if (sellingPlan) {
    item["selling_plan"] = sellingPlan;
  }

  const addResponse = await fetch('/cart/add.js', {
    method: "POST",
    body: JSON.stringify({
      items: [item],
      sections: ["cart-main", "dynamic-cart"]
    }),
    headers: {
      'Content-Type': "application/json"
    }
  });

  const addResponseJson = await addResponse.json();

  updateCart(addResponseJson);
}

/**
 * 
 * @param {String} lineItemKey - key of line item to upgrade
 * @param {String} upgradeVariantId - variant id of upsold product
 * @param {Int} quantity - quantity to add
 * @param {String} sellingPlan - id of upsold product selling plan if applicable
 */
export const upgradeProduct = async (lineItemKey, upgradeVariantId, quantity, sellingPlan = null) => {
  window.dispatchEvent(new Event('dynamic-cart-loading'));

  let itemToAdd = {
    id: upgradeVariantId,
    quantity: quantity
  }

  if (sellingPlan) {
    itemToAdd["selling_plan"] = sellingPlan;
  }

  const addResponse = await fetch('/cart/add.js', {
    method: "POST",
    body: JSON.stringify({
      items: [itemToAdd],
      sections: ["cart-main", "dynamic-cart"]
    }),
    headers: {
      'Content-Type': "application/json"
    }
  });

  const addResponseJson = await addResponse.json();

  if (!addResponse.ok) {
    updateCart(addResponseJson);
    return;
  }

  let itemToRemove = {
    id: lineItemKey,
    quantity: 0
  };

  const removeResponse = await fetch('/cart/change.js', {
    method: "POST",
    body: JSON.stringify({
      ...itemToRemove,
      sections: ["cart-main", "dynamic-cart"]
    }),
    headers: {
      'Content-Type': "application/json"
    }
  });

  const removeResponseJson = await removeResponse.json();

  if (!removeResponse.ok) {
    updateCart(addResponseJson);
  } else {
    updateCart(removeResponseJson);
  }
}

const serializeForm = (form) => {
  return Array.from(
    new FormData(form),
    e => e.map(encodeURIComponent).join('=')
  ).join('&')
}

/**
 * Adds a product to cart from a form
 *
 * @param {HTMLElement} formElement - Product form element
 */
export const addToCartForm = async (formElement) => {
  window.dispatchEvent(new Event('dynamic-cart-loading'));

  const cartResponse = await fetch('/cart/add.js', {
    method: "POST",
    body: serializeForm(formElement) + "&sections[]=cart-main&sections[]=dynamic-cart",
    headers: {
      'Content-Type': "application/x-www-form-urlencoded"
    }
  });

  const cartResponseJson = await cartResponse.json();

  updateCart(cartResponseJson);
}

/**
 * Change an item's quantity in the cart
 * @param {Int} id - variant id or line item key
 * @param {*} quantity - the new quantity
 */
export const changeCart = async (id, quantity) => {
  window.dispatchEvent(new Event('dynamic-cart-loading'));

  const changeResponse = await fetch('/cart/change.js', {
    method: "POST",
    body: JSON.stringify({
      id,
      quantity,
      sections: ["cart-main", "dynamic-cart"]
    }),
    headers: {
      'Content-Type': "application/json"
    }
  });

  const changeResponseJson = await changeResponse.json();

  updateCart(changeResponseJson, true);
}

/**
 * Change an item's quantity in the cart
 * @param {Int} id - variant id or line item key
 * @param {*} quantity - the new quantity
 */
 export const changeCartItemProperties = async (id, properties) => {
  window.dispatchEvent(new Event('dynamic-cart-loading'));

  const changeResponse = await fetch('/cart/change.js', {
    method: "POST",
    body: JSON.stringify({
      id,
      properties,
      sections: ["cart-main", "dynamic-cart"]
    }),
    headers: {
      'Content-Type': "application/json"
    }
  });

  const changeResponseJson = await changeResponse.json();

  updateCart(changeResponseJson, true);
}
